module.exports = __webpack_public_path__ + "92101f2ffc8923cf35a2382cf70475b8.svg";